import { Directive, Input, Renderer2, ElementRef } from '@angular/core';
import { Port } from 'src/app/models/port';
import { DeviceService } from 'src/app/services/device.service';

@Directive({
  selector: '[port-device-status]'
})
export class PortDeviceStatusDirective {

  @Input() port: Port;

  constructor(private deviceService: DeviceService,
    private renderer: Renderer2,
    private el: ElementRef) { }

  ngOnInit(): void {
    if (this.port.port_status == 0) {
      this.renderer.setStyle(this.el.nativeElement, 'stroke', 'goldenrod')
    }

    // Default port icon should be green when not in alarm
    if (this.port.port_status == 2) {
      this.renderer.setStyle(this.el.nativeElement, 'stroke', 'green')
    }

    let portDevice = this.deviceService.devices.find(x => x.dev_id == this.port.dev_id);
    // If device is offline gray it out
    if (portDevice && portDevice.dev_status == 1) {
      this.renderer.setStyle(this.el.nativeElement, 'stroke', 'gray')
    }

    // Port in alarm make it red, when warning orange outline it
    if (portDevice && portDevice.dev_operation_status == "OPERATIONAL") {
      if (this.port.port_status == 3)
        this.renderer.setStyle(this.el.nativeElement, 'stroke', 'orangered')
      else if (this.port.port_status == 1)
        this.renderer.setStyle(this.el.nativeElement, 'stroke', 'red')
    }
    // Special case when port in maintenance and in alarm/warning blue it out
    if (this.port.port_operation_status == "MAINTENANCE" && (this.port.port_status == 1 || this.port.port_status == 3)) {
      this.renderer.setStyle(this.el.nativeElement, 'stroke', 'blue')
    }
  }

}
